export const text = (value) => value?.trim() ?? '';
export const strings = (values) => (values ?? []).map(text).filter(Boolean);
export function safeUrl(value) {
    if (!value)
        return null;
    try {
        const url = new URL(value);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
    }
    catch {
        return null;
    }
}
export function resolveGallery(items = []) {
    const sorted = [...items].sort((a, b) => a.position - b.position || a.id.localeCompare(b.id));
    const seen = new Set();
    return sorted.filter(item => { const key = safeUrl(item.url); if (!key || seen.has(key))
        return false; seen.add(key); return true; });
}
export function visibleReviews(content) {
    return [...(content?.reviews ?? []), ...(content?.google?.reviews ?? []).map(review => ({ ...review, id: `google:${review.id}`, sources: [] }))];
}
export function visibleRating(content) {
    const ratings = visibleReviews(content).map(r => r.rating).filter((r) => typeof r === 'number' && Number.isFinite(r) && r > 0 && r <= 5);
    return ratings.length ? { ratingValue: Math.round(ratings.reduce((a, b) => a + b, 0) / ratings.length * 10) / 10, reviewCount: ratings.length } : null;
}
/** Slice at an original word boundary; concatenating lead and rest preserves every byte. */
export function splitLead(value, fits) {
    if (fits(value))
        return [value, ''];
    const ends = [...value.matchAll(/\S+(?:\s+|$)/g)].map(match => (match.index ?? 0) + match[0].trimEnd().length);
    let end = 0;
    for (const candidate of ends) {
        if (!fits(value.slice(0, candidate) + '…'))
            break;
        end = candidate;
    }
    return [value.slice(0, end), value.slice(end)];
}
/** Core credential dates are calendar dates. Format without a browser time-zone shift. */
export function displayDate(value) {
    const saved = text(value);
    const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|[ T])/.exec(saved);
    if (!match)
        return saved;
    const date = new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00Z`);
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== match[0].slice(0, 10))
        return saved;
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(date);
}
